<button mat-raised-button class="primary" (click)="newProject()" [disabled]="isProcessing">New</button>